var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronUp = function SvgChevronUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.999 7.071c.605 0 1.176.237 1.606.665L21.6 15.73l-1.07 1.07-7.995-7.994a.775.775 0 0 0-1.07 0L3.47 16.801 2.4 15.73l7.994-7.995A2.26 2.26 0 0 1 12 7.07z"
  })));
};
export default SvgChevronUp;